import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { startTestTimer } from "../../redux/test/actions";

const useTestAndQuesInfo = ({ id, mode, data }) => {
  const [agreeTerms, setAgreeTerms] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCheckboxChange = () => {
    setAgreeTerms((agreeTerms) => !agreeTerms);
  };

  const startTestHandler = () => {
    if (agreeTerms) {
      dispatch(startTestTimer(data.Time));
      navigate(`/mcq-test/${id}?exam-mode=${mode}`);
    }
  };

  return {
    agreeTerms,
    handleCheckboxChange,
    startTestHandler,
  };
};

export default useTestAndQuesInfo;
